import { z } from 'zod'
import { Currency } from '../../enums/currency.enum'

export const linkBrokerAccountSchema = z.object({
  displayCurrency: z.nativeEnum(Currency),
})

export type LinkBrokerAccountDto = z.infer<typeof linkBrokerAccountSchema>
